import { FetchResult, FetchResultType } from '@/entities/FetchResult'
import { Period } from '@/entities/Period/Period'
import { authorizedFetch } from '@/helpers/authorizedFetch'
import { generateDownloadURI } from '@/helpers/browser'
import { formatDate } from '@/helpers/date'
import { trans } from '@/helpers/trans'
import { generateApiV3Url } from '@/helpers/url'
import { DateFormat } from '@/types'

import { ScheduleShiftResource } from './Shift'

export const downloadShiftsIcalApiCall = async (
    userUuid: string,
    period: Period,
): Promise<FetchResult<boolean, string>> => {
    try {
        const url = generateApiV3Url({
            endpoint: `/shifts/ical-feed/${userUuid}`,
            queryParams: {
                start: formatDate(period.start, DateFormat.apiDate),
                end: formatDate(period.end, DateFormat.apiDate),
            },
        })

        const response = await authorizedFetch(url)
        const blob = await response.blob()

        if (! response.ok || ! blob) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const file = window.URL.createObjectURL(blob)
        generateDownloadURI(file, trans('common.valkSchedule'))

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: true,
        }
    } catch (error) {
        console.error('[downloadShiftsIcalApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}

export const fetchScheduleShiftsApiCall = async (
    startDate: Date,
    endDate: Date,
): Promise<FetchResult<ScheduleShiftResource[], string>> => {
    try {
        const url = generateApiV3Url({
            endpoint: '/me/shifts/department',
            queryParams: {
                startDate: formatDate(startDate, DateFormat.apiDate),
                endDate: formatDate(endDate, DateFormat.apiDate),
            },
        })

        const response = await authorizedFetch(url)
        const data = await response.json()

        if (! response.ok || ! data) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        return {
            status: response.status,
            type: FetchResultType.Success,
            data,
        }
    } catch (_error) {
        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
